<template v-bind:key="$route.path">
    <div class="wrapper" v-bind:key="$route.path">
        <router-link :to="'/' + $route.params.lang + '/inspirations'" class="button"><i class="fas fa-arrow-left" aria-hidden="true"></i> Zurück zur Übersicht</router-link>
        <div class="blogcontent">
            <div class="vimeo" style="padding:56.25% 0 0 0;position:relative;"><iframe :src="'https://player.vimeo.com/video/' + blog().video" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
            <h1>{{ blog().title }}</h1>
            <div v-for="matrix in blog().contentMatrix" class="matrix" :key="matrix.id">
                <div class="matrix-text" v-html="matrix.text"></div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        components: {
        },
        data(){
            return {
                page: {}
            }
        },
        methods: {
          blog(){
              let page = this.$route.params.inpage
              let blogsArray = this.$store.state.blogs.blogs
              for(var blog in blogsArray) {
                if(blogsArray[blog]['slug']==page) {
                  return blogsArray[blog]
                }
              }
          }
        }
    }
</script>

<style scoped lang="scss">
    figure {
        width: 80%;
        margin: 0 auto;

        img {
            width: 100%;
        }
    }
    .blogcontent {
        margin-top: 20px;
        p {
            font-size: 24px;
        }
    }
    .vimeo {
        width: 100%;
    }
    h1 {
        color: $orange;
        margin-top: 20px;
    }
    .matrix p {
        font-size: 24px;
    }
    .button {
        background-color: $orange;
    }
</style>
